module.exports = __webpack_public_path__ + "e89c9491f394c35d6c15db329b40f4e6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/lin-clark.jpg
 ** module id = 417
 ** module chunks = 0
 **/